import { createSelector } from '@ngrx/store';
import { AppState } from '../states/app.state';

export const selectCurrentUser = (state: AppState) => state.currentUser;

export const selectCurrentUserSub = createSelector(
  selectCurrentUser,
  (currentUser) => currentUser?.sub,
);
